import type { LocaleInput } from '@fullcalendar/core'
import frLocale from '@fullcalendar/core/locales/fr'

export const AGENDA_VIEWS = {
  month: 'dayGridMonth',
  week: 'timeGridWeek',
  day: 'timeGridDay',
  list: 'listWeek',
} as const

export type AgendaView = keyof typeof AGENDA_VIEWS
export type FCView = (typeof AGENDA_VIEWS)[AgendaView]

export const DEFAULT_AGENDA_VIEW: AgendaView = 'month'

export const AGENDA_VIEW_KEYS = Object.keys(AGENDA_VIEWS) as AgendaView[]

/** Reverse map: FullCalendar view type → URL view param */
export const FC_TO_URL_VIEW = Object.fromEntries(
  Object.entries(AGENDA_VIEWS).map(([k, v]) => [v, k])
) as Record<FCView, AgendaView>

/**
 * Upstream `fr`, with the toolbar's list button named « Liste » (upstream says
 * « Planning »), plus the hints `fr` leaves on FullCalendar's English defaults
 * (#2190): the list view's screen-reader column headers (FC hides that `thead`
 * off-screen) and the « +N » popover's close title.
 */
export const AGENDA_LOCALE: LocaleInput = {
  ...frLocale,
  buttonText: {
    ...frLocale.buttonText,
    list: 'Liste',
  },
  timeHint: 'Heure',
  eventHint: 'Intervention',
  closeHint: 'Fermer',
}
